import { parseWithZod } from "@conform-to/zod";
import {
  ActionFunctionArgs,
  json,
  LoaderFunctionArgs,
  type MetaFunction,
} from "@remix-run/node";
import {
  ADDRESS,
  ADDRESS_CITY,
  AUTHOR,
  BRAND,
  dateModified,
  datePublished,
  DESCRIPTION_PROD_SCHEME,
  LOGO,
  OG_IMAGE,
  POSTAL_CODE,
  PROFILE_FACEBOOK,
  PROFILE_IMAGE,
  PROFILE_INSTAGRAM,
  PROFILE_LINKEDIN,
  SITE_URL,
  SPAM_WORD_1,
  TWITTER_IMAGE,
  WHATSAPP_NUM,
} from "~/assets/profile/profile";
import { GlobalFormSchema } from "~/scheme/global_form_schema";
import { HomeSectionMenuLayanan } from "./home/components/HomeSectionMenuLayanan";
import { HomeSectionHero } from "./home/components/HomeSectionHero";
import { HomeSectionWhy } from "./home/components/HomeSectionWhy";
import HomeAnimatedLoader from "./home/components/HomeAnimatedLoader";
import HomeSectionBanner from "./home/components/HomeSectionBanner";
import { faqData, HomeSectionFAQ } from "./home/components/HomeSectionFAQ";
import { HomeSectionStep } from "./home/components/HomeSectionStep";
import { HomeSectionTopBanner } from "./home/components/HomeSectionTopBanner";
import GlobalMetaScripts from "~/components/global/GlobalMetaScripts";
import { useLoaderData } from "@remix-run/react";
import GlobalCompoVideo from "~/components/global/GlobalCompoVideo";
import { Navbar } from "~/components/layouts/Navbar";
import { Footer } from "~/components/layouts/footer/Footer";
import { JasaBangunRumahDiBekasiSect1TopBanner } from "./jasa-bangun-rumah-di-bekasi-landing/components/JasaBangunRumahDiBekasiSect1TopBanner";
import JasaBangunRumahDiBekasiSect4KamiHadir from "./jasa-bangun-rumah-di-bekasi-landing/components/JasaBangunRumahDiBekasiSect4KamiHadir";
import JasaBangunRumahDiBekasiSect5Portofolio from "./jasa-bangun-rumah-di-bekasi-landing/components/JasaBangunRumahDiBekasiSect5Portofolio";
import { GlobalYouTubeShortDrawer } from "~/components/global/GlobalYouTubeShortDrawer";
import JasaBangunRumahDiBekasiSect6Simulasi from "./jasa-bangun-rumah-di-bekasi-landing/components/JasaBangunRumahDiBekasiSect6Simulasi";
import { JasaBangunRumahDiBekasiSect8FAQ } from "./jasa-bangun-rumah-di-bekasi-landing/components/JasaBangunRumahDiBekasiSect8FAQ";
import { JasaBangunRumahDiBekasiSect9CTA } from "./jasa-bangun-rumah-di-bekasi-landing/components/JasaBangunRumahDiBekasiSect9CTA";
import GlobalContactWhatsappFormLanding from "~/components/global/GlobalContactWhatsappFormLanding";
import JasaBangunRumahDiBekasiSect4KamiHadir2 from "./jasa-bangun-rumah-di-bekasi-landing/components/test";
export const meta: MetaFunction = ({ data }) => {
  const title =
    `⭐️ NO 1 Ahlinya Jasa Renovasi | WA ${WHATSAPP_NUM}` ||
    `⭐️ NO 1 Ahlinya Renovasi | WA 08561921465 | Jasa Renovasi Di Demak`;
  const description = `⭐️ Gratis Konsultasi ! Renovasi atau Bangun rumah ? Dapatkan layanan bangun rumah profesional dengan hasil rapi, cepat, dan harga terjangkau! Hubungi kami sekarang untuk konsultasi GRATIS!`;
  const slug = `${SITE_URL}`;

  const keywords = [
    "Jasa Renovasi Rumah Bekasi",
    "Jasa Bangun Rumah Bekasi",
    "Kontraktor Rumah Bekasi",
    "Tukang Bangunan Bekasi",
    "Jasa Renovasi Murah Bekasi",
    "Jasa Perbaikan Rumah Bekasi",
    "Jasa Tukang Harian Bekasi",
    "Jasa Desain Rumah Bekasi",
    "Jasa Pasang Keramik Bekasi",
    "Jasa Tukang Plafon Bekasi",
    "Jasa Renovasi Dapur Bekasi",
    "Jasa Renovasi Kamar Mandi Bekasi",
  ].join(", ");

  const rating = "5.0";
  const author = AUTHOR; // Author of the page
  const publisher = AUTHOR; // Publisher of the page
  return [
    { title: `${title} | arsinesia.com` },
    { rel: "canonical", href: "https://arsinesia.com" },
    {
      name: "description",
      content: description,
    },
    {
      name: "keywords",
      content: keywords,
    },
    {
      property: "og:title",
      content: title,
    },
    {
      property: "og:description",
      content: description,
    },
    { property: "og:type", content: "website" },
    { property: "og:url", content: `${slug}` },
    { property: "og:image", content: OG_IMAGE },
    { name: "twitter:card", content: "summary_large_image" },
    {
      name: "twitter:title",
      content: title,
    },
    {
      name: "twitter:description",
      content: description,
    },
    { name: "twitter:image", content: TWITTER_IMAGE },
    { name: "viewport", content: "width=device-width, initial-scale=1.0" },
    // Additional SEO Meta Tags
    { name: "rating", content: rating },
    { name: "author", content: author },
    { name: "publisher", content: publisher },
    { name: "datePublished", content: datePublished },
    { name: "dateModified", content: dateModified },
    { name: "robots", content: "index, follow" }, // Allows search engines to index the page
    {
      name: "robots",
      content: "max-snippet:-1, max-image-preview:large, max-video-preview:-1", // Controls the preview type
    },
    {
      property: "og:rating",
      content: rating, // Added rating for OG meta
    },
    {
      property: "og:author",
      content: author, // Added author for OG meta
    },
    {
      property: "og:publisher",
      content: publisher, // Added publisher for OG meta
    },
    {
      property: "og:datePublished",
      content: datePublished, // Added publish date for OG meta
    },
    {
      property: "og:dateModified",
      content: dateModified, // Added modify date for OG meta
    },
    {
      property: "schema.org/Organization", // Structured data (JSON-LD)
      content: JSON.stringify({
        "@context": "http://schema.org",
        "@type": "Organization",
        name: publisher,
        url: SITE_URL,
        logo: LOGO, // Replace with your logo URL
        sameAs: PROFILE_FACEBOOK, // Replace with social media URLs
      }),
    },
  ];
};
export const loader = async ({ request }: LoaderFunctionArgs) => {
  try {
    return json({
      // sheetScript,
      structuredData: {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: BRAND,
        url: SITE_URL,
        logo: LOGO,
        sameAs: [PROFILE_FACEBOOK, PROFILE_INSTAGRAM, PROFILE_LINKEDIN],
      },
      // BUSINESSCHEMA
      businessSchema: {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        name: BRAND,
        image: LOGO,
        address: {
          "@type": "PostalAddress",
          streetAddress: ADDRESS,
          addressLocality: ADDRESS_CITY,
          postalCode: POSTAL_CODE,
          addressCountry: "ID",
        },
        telephone: WHATSAPP_NUM,
        priceRange: "Rp3.000 - Rp40.000",
        openingHoursSpecification: [
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            opens: "09:00",
            closes: "18:00",
          },
        ],
      },
      // SERVICECHEMA
      serviceSchema: {
        "@context": "https://schema.org",
        "@type": "Service",
        name: SPAM_WORD_1,
        provider: {
          "@type": "Organization",
          name: AUTHOR,
          url: SITE_URL,
        },
      },
      // PRODUCTSCHEMA
      productSchema: {
        "@context": "https://schema.org",
        "@type": "Product",
        name: SPAM_WORD_1,
        description: DESCRIPTION_PROD_SCHEME,
        brand: {
          "@type": "Brand",
          name: AUTHOR,
        },
        sku: "GR-001",
        gtin: "123456789012",
        image: PROFILE_IMAGE,
        offers: {
          "@type": "Offer",
          price: "2000000",
          priceCurrency: "IDR",
          availability: "https://schema.org/InStock",
          url: SITE_URL,
          priceValidUntil: "2025-12-31",
          shippingDetails: {
            "@type": "OfferShippingDetails",
            shippingRate: {
              "@type": "MonetaryAmount",
              value: "10000",
              currency: "IDR",
            },
            shippingDestination: {
              "@type": "DefinedRegion",
              addressCountry: "ID",
            },
            deliveryTime: {
              "@type": "ShippingDeliveryTime",
              handlingTime: {
                "@type": "QuantitativeValue",
                minValue: 1,
                maxValue: 2,
                unitCode: "DAY",
              },
              transitTime: {
                "@type": "QuantitativeValue",
                minValue: 2,
                maxValue: 4,
                unitCode: "DAY",
              },
            },
          },
          hasMerchantReturnPolicy: {
            "@type": "MerchantReturnPolicy",
            applicableCountry: "ID",
            returnPolicyCategory:
              "https://schema.org/MerchantReturnFiniteReturnWindow",
            merchantReturnDays: 7,
            returnMethod: "https://schema.org/ReturnByMail",
            returnFees: "https://schema.org/FreeReturn",
          },
        },
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "4.8",
          reviewCount: "2248",
        },
      },
      webPageSchema: {
        "@context": "http://schema.org",
        "@type": "WebPage",
        "@id": `${SITE_URL}`,
        url: `${SITE_URL}`,
        name: "Jasa Renovasi Rumah Di Bekasi",
        description: "Jasa Renovasi Rumah Di Bekasi",
        datePublished: "2025-01-29",
        dateModified: "2025-02-20",
        author: {
          "@type": "Organization",
          name: AUTHOR,
          url: SITE_URL,
        },
      },
      // BreadcrumbList Schema
      breadcrumbSchema: {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
          {
            "@type": "ListItem",
            position: 2,
            name: "Jasa Tukang Di Demak",
            item: `${SITE_URL}`,
          },
          {
            "@type": "ListItem",
            position: 3,
            name: `Jasa Renovasi Rumah Di Bekasi`,
            item: `${SITE_URL}`,
          },
        ],
      },
      faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqData.map((faq) => ({
          "@type": "Question",
          name: faq.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: faq.answer,
          },
        })),
      },
    });
  } catch (error) {
    return json({ error: (error as Error).message }, { status: 500 });
  }
};
export const action = async ({ request }: ActionFunctionArgs) => {
  const formData = await request.formData();
  const { payload } = parseWithZod(formData, { schema: GlobalFormSchema });

  formData.append("Date", new Date().toISOString());
  formData.append("Whatsapp", String(payload?.whatsapp));

  return json({ msg: "success" });
};

export default function Index() {
  const {
    structuredData,
    serviceSchema,
    businessSchema,
    productSchema,
    webPageSchema,
    breadcrumbSchema,
    faqSchema,
  } = useLoaderData<{
    structuredData: any;
    serviceSchema: any;
    businessSchema: any;
    productSchema: any;
    webPageSchema: any;
    breadcrumbSchema: any;
    faqSchema: any;
  }>();
  return (
    <>
      <GlobalMetaScripts
        structuredData={structuredData}
        serviceSchema={serviceSchema}
        businessSchema={businessSchema}
        productSchema={productSchema}
        webPageSchema={webPageSchema}
        breadcrumbSchema={breadcrumbSchema}
        faqSchema={faqSchema}
      />
      <Navbar />
      <JasaBangunRumahDiBekasiSect1TopBanner />
      <section className="w-global mx-auto min-h-screen ">
        <JasaBangunRumahDiBekasiSect4KamiHadir />
      </section>
      <section className="w-global mx-auto min-h-screen " id="proyek-kami">
        <JasaBangunRumahDiBekasiSect5Portofolio />
      </section>
      <section className="w-full">
        <GlobalYouTubeShortDrawer />
      </section>

      <div className="pt-[5rem] pb-[5rem] flex flex-col justify-center  text-center">
        <img src="https://ik.imagekit.io/didigi/bangun-rumah-di-bekasi/proyek-bangun-arsinesia.webp" />
        <h3 className="text-black font-semibold text-[30px]">
          Dan Masih Banyak Lagi
        </h3>
      </div>
      <section id="simulasi-gratis">
        <JasaBangunRumahDiBekasiSect6Simulasi />
      </section>
      <div className="w-global mx-auto min-h-screen pb-[7rem]">
        <JasaBangunRumahDiBekasiSect8FAQ />
      </div>
      <section className="p-4 fixed right-2 bottom-0 lg:right-6 lg:bottom-6 z-50 rounded-xl">
        <GlobalContactWhatsappFormLanding
          buttonText="Konsultasi Gratis"
          classnameButton="py-[2rem] bg-green-500"
          classnameText="text-xl"
        />
      </section>

      <Footer />
    </>
  );
}
